<template>
  <tooltip
    v-if="showTooltip"
    :content="content"
    placement="top-start"
    popper-class="overflow-tip"
    :raw-content="rawContent"
    :effect="effect"
  >
    <template #content>
      <div
        :style="{
          width: popperContentWidth !== 'auto' ? popperContentWidth + 'px' : '',
        }"
      >
        <slot v-if="$slots.content" name="content" /><span v-else>{{
          content
        }}</span>
      </div>
    </template>
    <div :style="getDisplayStyle()" :class="ns.b()" @click="handleClick">
      <slot v-if="$slots.content" name="content" /><span v-else>{{
        content
      }}</span>
    </div>
  </tooltip>
  <div v-else :style="getDisplayStyle()" :class="ns.b()" @click="handleClick">
    {{ content }}
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import tooltip from '@lit-element/components/tooltip/src/tooltip.vue'
import { useNamespace } from '@lit-element/hooks'
import { ellipsisProps } from './ellipsis'
import type { StyleValue } from 'vue'

defineOptions({
  name: 'LtEllipsis',
})

const ns = useNamespace('ellipsis')
const rawContent = ref(false)
const props = defineProps(ellipsisProps)
const isExpanded = ref(false) // 初始化为 false，表示默认折叠

const getEllipsisStyle = (): StyleValue => {
  if (props.maxLines > 0) {
    return {
      '-webkit-line-clamp': props.maxLines,
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      'text-overflow': 'ellipsis',
      'word-break': 'break-all',
      cursor: 'pointer',
    }
  }
  return {}
}

const getDisplayStyle = (): StyleValue => {
  if (isExpanded.value) {
    return {}
  }
  const baseStyle = getEllipsisStyle() as Record<string, string | number>
  return {
    ...baseStyle,
    width: `${props.width}px`,
    overflow: 'hidden',
    cursor: 'pointer',
    'text-overflow': 'ellipsis',
  }
}

const handleClick = () => {
  if (props.expandTrigger === 'click') {
    isExpanded.value = !isExpanded.value
  }
}
</script>
<style lang="scss" scoped></style>
